const lightSkin = {
  "border-separator-color": "#dee2e6",
  "table-hover-background": "#dddddd",
  "input-light-background": "#ffffff",
  "light-background": "#ffffff",
  "dark-background": "#dddddd",
  "dark-background-text-color": "#212529",
  "default-background": "#ffffff",
  "default-text-color": "#212529",
  "emphasis-background-color": "#2394fd",
  "emphasis-text-color": "#ffffff",
  "selected-background-color": "#2684FF",
  "selected-text-color": "#ffffff",
  "unchecked-background-color": "#ffffff",
  "input-background-color": "#ffffff",
  "box-shadow-primary":
    "0 0 0 1px hsla(0, 0%, 0%, 0.2),0 4px 11px hsla(0, 0%, 0%, 0.2)",
};

export default lightSkin;
